<template>
    <div>
        <el-row>
            <el-col :xs="24" :sm="12" :md="8" :lg="6" class="add">
                <i class="el-icon-plus" @click="handleAdd"></i>
                <ml-card :edit="true" @click.native="() => {}"></ml-card>
            </el-col>
            <el-col
                :xs="24"
                :sm="12"
                :md="8"
                :lg="6"
                v-for="item in info"
                :key="item.id"
            >
                <ml-card
                    :info="item"
                    :edit="true"
                    @click.native="handleClick(item)"
                ></ml-card>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { showVirtualSimulation } from "@/api/views/virtualExp";

import MlCard from "@/components/MlCard";

export default {
    name: "Index",
    components: {
        MlCard
    },
    data() {
        return {
            info: [],
            search: {}
        };
    },
    created() {
        showVirtualSimulation({
            page: 1,
            showNum: 18,
            fuzeren: this.$store.state.userInfo.name
        }).then(res => {
            res.virtualList.forEach(item => {
                this.info.push({
                    id: item.id,
                    imageUrl:
                        item.video_img ||
                        "http://sjjx.dlou.edu.cn/uploads/default.png",
                    title: item.exp_name || item.title,
                    school: item.school_name,
                    leader: item.fuzeren,
                    count: item.expcidtimeCount,
                });
            });
        });
    },
    methods: {
        handleAdd() {
            let { href } = this.$router.resolve({ path: "/expInfo" });
            window.open(href, "_blank");
        },
        handleClick(item) {
            let { href } = this.$router.resolve({
                path: "/expInfo?id=" + item.id
            });
            window.open(href, "_blank");
        }
    }
};
</script>

<style lang="scss" scoped>
.ml-card {
    margin: 8px;
    font-size: 14px;
}

.add {
    position: relative;

    .el-icon-plus {
        position: absolute;
        width: 100%;
        margin: 8px;
        font-size: 40px;
        line-height: 202px;
        text-align: center;
        cursor: pointer;
    }
    /deep/ .el-card__body {
        height: 202px;

        div {
            display: none;
        }
    }
}
</style>
